const FINDINGS_STORAGE_KEY_PREFIX = 'copilot-findings:v1'

export const filtersStorageKey = (pullRequestBasePath: string) =>
  `${FINDINGS_STORAGE_KEY_PREFIX}:${pullRequestBasePath}:filters`

export const expandedFindingsStorageKey = (pullRequestBasePath: string) =>
  `${FINDINGS_STORAGE_KEY_PREFIX}:${pullRequestBasePath}:expanded`
